<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import _ from "lodash";

export default {
  page: {
    title: "Log Aktivitas",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
  },
  data() {
    let sortOrders = [];

    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "auto",
        label: "Username",
        name: "username",
      },
      {
        width: "auto",
        label: "Menu",
        name: "menu",
      },
      // {
      //   width: "auto",
      //   label: "Tipe Aktifitas",
      //   name: "type",
      // },
      {
        width: "50%",
        label: "Url",
        name: "type",
      },
      {
        width: "150px",
        label: "Waktu Aktifitas",
        name: "date",
      },
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Log Aktivitas",
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "date",
      sortOrders: sortOrders,
      currentTablePage: "",
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "date",
        dir: "desc",
        username: "",
        menu: "",
        type: "",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  async mounted() {
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);
    await this.getDataTable();
  },
  methods: {
    fullDateTimeFormat(datetime) {
      return moment(datetime).format("YYYY-MM-DD HH:mm:ss");
    },
    async getDataTable(resetPage = true) {
      this.loadingTable = true;

      let payload = { ...this.tableFilter };

      if (resetPage) {
        this.tableFilter.page = 1;
      }

      axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "log/activity",
        params: payload,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      })
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200) {
            this.table_data = response_data.data.data;
            this.configPagination(response_data.data);
            this.currentTablePage = response_data.data.current_page;
            this.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.data.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    toPage: function (url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getDataTable(false);
    },
    exportData() {
      const params = new URLSearchParams(this.tableFilter).toString();
      window.open(
        `${process.env.VUE_APP_BACKEND_URL_VERSION}export-excel/log-activity?${params}`,
        "_blank"
      );
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="card-title">Log Aktivitas</div>
              </div>
              <div class="col-md-6">
                <div class="text-end">
                  <button class="btn btn-sm btn-success" @click="exportData">
                    <i class="fa fa-file-excel"></i> Export Excel
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <hr />
                <div class="row">
                  <div class="form-group col-md-3">
                    <label for="filterUsername">Username</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Filter Username"
                      v-model="tableFilter.username"
                      @input="filterData"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label for="filterMenu">Menu</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Filter Menu"
                      v-model="tableFilter.menu"
                      @input="filterData"
                    />
                  </div>
                  <!-- <div class="form-group col-md-3">
                    <label for="filterType">Type</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Filter Type"
                      v-model="tableFilter.type"
                      @input="filterData"
                    />
                  </div> -->
                </div>
                <hr />
              </div>
              <div class="col-md-12 mb-2">
                <div class="row">
                  <div class="col-md-4">
                    <table>
                      <tr>
                        <td>Show</td>
                        <td>
                          <select
                            class="form-control form-control-sm"
                            style="width: 100%"
                            v-model="tableFilter.per_page"
                            @change="getDataTable()"
                          >
                            <option value="10" selected>10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </td>
                        <td>Entries</td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-md-5">&nbsp;</div>
                  <div class="col-md-3">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Cari Data ..."
                      v-model="tableFilter.search"
                      @input="getDataTable()"
                    />
                  </div>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <datatable
                  :columns="columns"
                  :sortKey="sortKey"
                  :sortOrders="sortOrders"
                  @sort="sortBy"
                >
                  <tbody>
                    <tr v-if="loadingTable">
                      <td colspan="99" class="text-center">
                        <i class="fas fa-spinner fa-spin"></i> Loading...
                      </td>
                    </tr>
                    <tr v-else-if="table_data.length === 0">
                      <td class="text-center" colspan="99">
                        Data Tidak Tersedia
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="(row_data, key_data) in table_data"
                      :key="key_data"
                    >
                      <td class="text-center">
                        {{ pagination.from + key_data }}
                      </td>
                      <td>
                        {{ row_data.username }}
                      </td>
                      <td>
                        {{ row_data.menu }}
                      </td>
                      <!-- <td>
                        {{ row_data.type }}
                      </td> -->
                      <td>
                        {{ row_data.url }}
                      </td>
                      <td class="text-center">
                        {{ fullDateTimeFormat(row_data.date) }}
                      </td>
                    </tr>
                  </tbody>
                </datatable>
              </div>
            </div>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
